<template>
  <div>
    <Header>
      <v-spacer />
      <v-btn href="https://note.com/nesting_me/n/n7bb4a44fca88">
        <v-icon left>
          mdi-help
        </v-icon>
        使い方
      </v-btn>
    </Header>
    <v-main>
      <v-container class="px-10">
        <div class="mt-10">
          NESTINGアプリは、ベースとなるテンプレートをもとに、お好みの内観・外観のスタイルへ変更し、金額も試算できるアプリケーションです。
          <a
            class="text-decoration-underline text-caption"
            href="https://note.com/nesting_me/n/n7bb4a44fca88"
          >
            詳しい使い方を見る
          </a>
        </div>
        <v-card
          class="flex d-flex flex-column py-2"
          link
          :to="{ name: 'Model', params: {} }"
        >
          <v-img
            :cover="true"
            :src="image"
            height="320px"
          />
          <v-card-title class="pb-0 mb-1">
            <v-icon left>
              mdi-pencil
            </v-icon>
            エディター画面へ
          </v-card-title>
        </v-card>
      </v-container>
    </v-main>
    <v-dialog v-model="state.video">
      <div class="d-flex justify-center align-center">
        <iframe
          class="d-block"
          style="
            width: 560px;
            height: 315px;
            max-width: calc(100vw - 80px);
            max-height: calc(100vh - 80px);
          "
          src="https://www.youtube.com/embed/PnwWKpcdAZo?autoplay=1"
          frameborder="0"
          allowfullscreen
        />
      </div>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from "vue";
import Header from "../components/Header.vue";
import ModelList from "../components/ModelList.vue";

export default defineComponent({
  name: "Home",

  components: {
    Header,
    ModelList
  },

  setup() {
    const state = reactive({
      video: false,
    });

    return {
      state,
    };
  },

  data: () => {
    return {
      image: require("@/assets/images/top/Kiritsuma_A_optimized.jpg"),
    };
  },
});
</script>

<style lang="scss" scoped>
.header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
